<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="收支ID">
              <el-input v-model="queryParams.id" @change="search" @clear="search" placeholder="请输入收支ID"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="收支名称">
              <el-input v-model="queryParams.name" @change="search" @clear="search" placeholder="请输入收支名称"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="收支类型">
              <el-select v-model="queryParams.type" placeholder="请选择状态" @change="search" @clear="search" clearable
                         class="w100">
                <el-option label="收入" value="1"></el-option>
                <el-option label="支出" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="状态">
              <el-select v-model="queryParams.status" placeholder="请选择状态" @change="search" clearable style="width: 100%;">
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="addNoNe" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column label="ID">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column prop="name" label="收支类型">
          <template slot-scope="scope">{{ scope.row.type_text }}</template>
        </el-table-column>

        <el-table-column prop="name" label="收支名称">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>

        <el-table-column prop="name" label="备注">
          <template slot-scope="scope">{{ scope.row.remark }}</template>
        </el-table-column>

        <el-table-column prop="name" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>禁用</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="排序">
          <template slot-scope="scope">
            <el-tooltip placement="bottom" v-if="showWeight[scope.$index]">
              <div slot="content" v-html="clickText"></div>
              <span class="description-span" @click="setToNumber(scope.$index)">{{ scope.row.weight }}</span>
            </el-tooltip>
            <el-input
                class="custom-input"
                v-if="!showWeight[scope.$index]"
                v-model="scope.row.weight"
                @input="validateInput(scope.row)"
                @blur="editShowWeight(scope.$index)"
                @change="editWeight(scope.$index, scope.row)"
                style="width: 40%;"
                maxlength="5"
                v-focus
                :min="0"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                  :limit.sync="queryParams.pageSize" @pagination="getList"/>
      <TradeTypeEdit v-if="AddTradeTypeFlag" :AddTradeTypeFlag="AddTradeTypeFlag" @NoneDlog="NoneDlog" @AddOk="AddOk"
                     :editID="editID">
      </TradeTypeEdit>
    </el-card>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";
import TradeTypeEdit from "./edit.vue"

export default {
  components: {
    TradeTypeEdit
  },
  data() {
    return {
      form: {
        name: ""
      },
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        name: "",
        id:'',
      },
      page: {
        pageNo: 1,
        pageSize: 999,
      },

      tableData: [],
      dialogVisible: false,
      editID: "",
      // 总条数
      total: 0,
      AddTradeTypeFlag: false,
      loading: false,
      showWeight: {}, // 存储每一行的显示状态
      weightValue: 0,
      clickText: "点击编辑",
    };
  },
  created() {
    this.getList()
  },
  methods: {

    getList() {
      this.loading = true
      let api = MoneyManagementAPI()
      api.getTradeTypeList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
        for (let i = 0; i < this.total; i++) {
          this.$set(this.showWeight, i, true);
        }
      })
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    search() {
      this.getList()
    },

    setToNumber(index) {
      for (let i = 0; i < this.total; i++) {
        this.$set(this.showWeight, i, true);
      }
      this.$set(this.showWeight, index, false); // 设置特定行的状态为 false
    },

    validateInput(row) {
      // 使用正则表达式验证输入值
      const regex = /^[0-9]*$/; // 只允许输入非负整数
      if (!regex.test(row.weight)) {
        // 如果输入不符合要求，重置为0
        row.weight = 0;
      }
    },

    editShowWeight(index) {
      this.$set(this.showWeight, index, true); // 设置特定行的状态为 false
    },

    editWeight(index, data) {
      this.$set(this.showWeight, index, true); // 设置特定行的状态为 true
      if (data.weight == null) {
        data.weight = 0
      }
      let api = MoneyManagementAPI()
      api.tradeTypeAdded(data).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "修改成功",
            type: 'success'
          });
          this.$emit('AddOk');
          this.getList();
        } else {
          processErrors(res);
        }
      })
    },

    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        name: "",
        id:'',
      }
      this.getList()
    },
    addList() {
      this.editID = ""
      this.AddTradeTypeFlag = true
    },
    NoneDlog() {
      this.AddTradeTypeFlag = false
    },
    AddOk() {
      this.editID = ""
      this.AddTradeTypeFlag = false
      this.getList()
    },
    addEdit(row) {
      this.editID = row.id
      this.AddTradeTypeFlag = true
    },
  },

  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector("input").focus();
      },
    },
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }

  .custom-input ::v-deep .el-input__inner {
    text-align: center;
  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>